<template>
  <el-dialog
    title="确认通过"
    :visible.sync="dialogVisible"
    width="620px"
    append-to-body
    @closed="reset"
  >
    <el-form label-width="155px">
      <el-form-item
        :label="Number(row.type) === 1 ? '实际生效日期' : '生效日期'"
        ><el-date-picker
          v-model="effectDate"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:100%"
          @change="calculate"
      /></el-form-item>
      <template v-if="Number(row.type) === 2">
        <el-form-item label="原加保保费(元)"
          ><el-input-number
            v-model="oldAddPrice"
            :controls="false"
            disabled
            style="width:100%"
        /></el-form-item>
        <el-form-item label="订单使用挂账金额(元)"
          ><el-input-number
            v-model="useAmount"
            :controls="false"
            :min="0"
            style="width:100%"
            @change="recalculate"
        /></el-form-item>
        <el-form-item label="客户应支付金额(元)"
          ><el-input-number
            v-model="payableAmount"
            :controls="false"
            disabled
            style="width:100%"
        /></el-form-item>
        <el-form-item label="客户实际支付金额(元)"
          ><el-input-number
            v-model="actualAmount"
            :controls="false"
            :min="0"
            style="width:100%"
            @change="recalculate"
        /></el-form-item>
        <el-form-item label="批单加保保费(元)"
          ><el-input-number
            v-model="addPrice"
            :controls="false"
            :min="0"
            style="width:100%"
            @change="recalculate"
        /></el-form-item>
        <el-form-item label="登记挂账余额(元)"
          ><el-input-number
            v-model="creditAmount"
            :controls="false"
            style="width:100%"
        /></el-form-item>
        <el-form-item label="备注"><el-input v-model="note"/></el-form-item>
      </template>
      <el-form-item label="批单号"
        ><el-input v-model.trim="endorsementNo"
      /></el-form-item>
      <el-form-item label="批单文件"
        ><employer-file-upload v-model="endorsementUrl"
      /></el-form-item>
    </el-form>
    <span slot="footer"
      ><el-button @click="dialogVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submit"
        >确定</el-button
      ></span
    >
  </el-dialog>
</template>
<script>
import {
  calculateEmployerAddPrice,
  confirmEmployerAdd,
  confirmEmployerChange
} from "@/api/employer-insurance";
import EmployerFileUpload from "./EmployerFileUpload.vue";
export default {
  name: "HistoryConfirmDialog",
  components: { EmployerFileUpload },
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      submitting: false,
      effectDate: "",
      oldAddPrice: 0,
      useAmount: 0,
      payableAmount: 0,
      actualAmount: 0,
      addPrice: 0,
      creditAmount: 0,
      note: "",
      endorsementNo: "",
      endorsementUrl: ""
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      }
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.oldAddPrice = Number(this.row.total_add_price || 0) / 100;
        this.useAmount = Math.min(
          Number(this.row.credit_amount || 0) / 100,
          this.oldAddPrice
        );
        this.actualAmount = this.oldAddPrice - this.useAmount;
        this.payableAmount = this.actualAmount;
        this.addPrice = this.oldAddPrice;
        this.recalculate();
      }
    }
  },
  methods: {
    async calculate() {
      if (!this.effectDate || Number(this.row.type) !== 2) return;
      const res = await calculateEmployerAddPrice({
        order_id: Number(this.row.order_id),
        group_no: this.row.group_no,
        effect_date: this.effectDate
      });
      if (res && res.total_price != null) {
        this.addPrice = Number(res.total_price) / 100;
        this.recalculate();
      }
    },
    recalculate() {
      this.payableAmount = Math.max(0, this.oldAddPrice - this.useAmount);
      this.creditAmount =
        (this.useAmount - (this.addPrice - this.actualAmount)).toFixed(2) * 1;
    },
    async submit() {
      if (!this.effectDate) {
        this.$message.warning("请选择生效日期");
        return;
      }
      this.submitting = true;
      try {
        let res;
        if (Number(this.row.type) === 1) {
          res = await confirmEmployerChange({
            order_id: Number(this.row.order_id),
            group_no: this.row.group_no,
            effected_at: this.effectDate,
            endorsement_url: this.endorsementUrl,
            endorsement_no: this.endorsementNo
          });
        } else {
          res = await confirmEmployerAdd({
            order_id: Number(this.row.order_id),
            group_no: this.row.group_no,
            effect_date: this.effectDate,
            note: this.note,
            use_amount: Math.round(this.useAmount * 100),
            actual_amount: Math.round(this.actualAmount * 100),
            payable_amount: Math.round(this.payableAmount * 100),
            credit_amount: Math.round(this.creditAmount * 100),
            old_add_price: Math.round(this.oldAddPrice * 100),
            add_price: Math.round(this.addPrice * 100),
            endorsement_url: this.endorsementUrl,
            endorsement_no: this.endorsementNo
          });
        }
        if (!res) return;
        this.$message.success("确认成功");
        this.dialogVisible = false;
        this.$emit("success");
      } finally {
        this.submitting = false;
      }
    },
    reset() {
      Object.assign(this.$data, {
        submitting: false,
        effectDate: "",
        oldAddPrice: 0,
        useAmount: 0,
        payableAmount: 0,
        actualAmount: 0,
        addPrice: 0,
        creditAmount: 0,
        note: "",
        endorsementNo: "",
        endorsementUrl: ""
      });
    }
  }
};
</script>
